export default function CsharpTernary() {
  return (
    <h2>Csharp Ternary</h2>
  );
}
